
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hero/article/[urlName]",
      function () {
        return require("private-next-pages/hero/article/[urlName].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hero/article/[urlName]"])
      });
    }
  